<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container">

					<div class="modal-header">

						<div class="modal-close" v-on:click="close">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
							  <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path>
							</svg>
						</div>
						<span> IMPORT EXISTING WALLET  </span> 
					</div>

					

					<div class="modal-body">

						<form v-on:submit.prevent="onImport"> 
			     			<div class="alert alert-danger" v-if="showError"> {{ systemMsg }} </div>
			     			
			   
							  
							   <div class="form-group">
							   	 <label for="privkey">Your Private Key:</label>
								  <input type="text" id="privateKey" name="privateKey" v-model="importWallet.privateKey"  class="form-control" >
								  <span class="help-block" v-if="errors.privateKey != ''"> {{ errors.privateKey }} </span> 

							  </div>
							  
							  
							  <div class="flex  margin-top">
			    				<button  class="btn btn-main" type="submit">  
			    					<span>Import</span>	
			    				</button>
			    				 
			    			</div>
			    			
			    			
							</form>
					</div>
 

				</div>
			</div>
		</div>

	</transition>
</template>

<script> 


  import qs from 'querystring'
	export default {
		name: 'ImportWallet',
		computed: {
	      	init() {
	        	return this.$store.state.init;
	      	},
	    },
	    data: function() {
			return {
				showError: false,
				importWallet: {
		      		privateKey: ''
		      	},
		      	errors: { 
					privateKey: ""
				},
				systemMsg: ""
			}
		},
		methods: {
			close: function(){
				this.init.show.importWallet = false;
			},
 			
 			onImport: function(){
				let hasError = false;

				
				
				if(this.importWallet.privateKey == '' || this.importWallet.privateKey == undefined || this.importWallet.privateKey == null) {
					this.errors.privateKey = 'Private key is required.';
					hasError = true;
				}
				 
				if(!hasError) {
					this.showError = false;
					 this.axios.post('/cx/address/import',
						qs.stringify({ 
						    "privateKey": this.importWallet.privateKey
						}))
		            .then((response) => { 
		             
		                console.log(response.data); 
									window.location.href = "/#/";
						
		            }).catch((err) => {
			
			
		                if(err) {
	                  	 this.showError = true;
						
							if(err.response.data.msgCode == "99999") {
								this.systemMsg = "Invalid Private Key."	
							} else {
								if(err.response.data.fieldErrors) {
									this.systemMsg = err.response.data.fieldErrors[0].defaultMessage;
								}
								
							}
							
						} 

		            }).finally ( ()=> {
						setTimeout(() => {
							this.showError = false;
							this.systemMsg = '';
						},3000)
					
					})
				}
				
			},


		},
		mounted() {

			this.errors.msg = "";
			
    	},
    	watch: {
    		'importWallet.privateKey': function(newValue, oldValue) {
				
		        if(newValue != oldValue) {  

		        	this.errors.privateKey  = '';
		        	this.systemMsg = '';
		        	this.showError = false;
		        }
		    },
    	}
	}

</script>


<style lang="scss" scoped>
	.btn-main {
		font-weight: bold;
	}
	
</style>